export default __webpack_public_path__ + "static/media/sidus_icon.3b3ceb6f.jpg";